import { DropdownSelect } from "@vds/selects";
import { Body } from "@vds/typography";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomTFDaysInWeek,
  CustomTFDropdownsFrame,
  CustomTFFrame,
  DayOfTheWeekText,
  FrameForDay,
  TimeFrameText,
} from "../../../global/components/Modals/RoiModals/stylesRoiModal";
import { updateRuleValue } from "../../../store/actions";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";
import { useWindowSize } from "../../../global/hooks/viewportHooks";

const CustomTimeFrame = (props) => {
  const { width } = useWindowSize();
  const isReadOnly = props?.isReadOnly || false;
  const {
    triggerActions: {
      customData,
    },
  } = useSelector((state) => state.ruleReducer);
  const {selectedDays ={},startTime = "12:00 AM",endTime = "12:30 AM",timeParam = "", overNightText= false, timeZone="ET"} = customData;
  const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const timeZones = [{title: "Eastern Time Zone" , value:"ET"}, 
    {title: "Central Time Zone" , value:"CT"}, 
    {title: "Mountain Time Zone" ,value:"MT"}, 
    {title: "Pacific Time Zone" , value:"PT"}];

  const dispatch = useDispatch();
  const toggleDaySelection = (day) => {
    const prevSeldays = { ...selectedDays };
    prevSeldays[day] = !prevSeldays[day];
    dispatch(
      updateRuleValue({
        propName: "customData",
        value: { selectedDays: prevSeldays },
      })
    );
  };

  const setTimeParam = (val) => {
    dispatch(
      updateRuleValue({ propName: "customData", value: { timeParam: val, overNightText: showText } })
    );
  };

  const timeOptions = Array.from({ length: 48 }, (_, i) => {
    const hour = Math.floor(i / 2);
    const minute = i % 2 === 0 ? "00" : "30";
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${formattedHour}:${minute} ${period}`;
  }).concat("11:59 PM");

  const timeValues = timeOptions.map((time) => {
    const [timePart, period] = time.split(" ");
    let [hour, minute] = timePart.split(":");
    hour = parseInt(hour);
    minute = parseInt(minute);

    if (period === "PM" && hour !== 12) {
      hour += 12;
    } else if (period === "AM" && hour === 12) {
      hour = 0;
    }

    return hour * 60 + minute;
  });

  const startTimeValue = timeValues[timeOptions.indexOf(startTime)];
  const filteredEndTimeOptions = timeOptions.filter(
    (_, index) => timeValues[index] > startTimeValue
  );

  const showText =
    filteredEndTimeOptions &&
    !filteredEndTimeOptions?.some((time) => time == endTime);


  const setTime = (timeFor, newTime) => {
    dispatch(
      updateRuleValue({ propName: "customData", value: { [timeFor]: newTime, overNightText: showText } })
    );
  };

  useEffect(() => {
    const nextEndTime = filteredEndTimeOptions[0];
    // console.log('filteredEndTimeOptions[0] >>>>>2', nextEndTime, startTime);
    if (!endTime)
      dispatch(
        updateRuleValue({
          propName: "customData",
          value: { endTime: nextEndTime, overNightText: showText },
        })
      );
  }, [filteredEndTimeOptions && startTime]);

  return (
    <>
      <CustomTFFrame>
        <CustomTFDropdownsFrame>
          <DropdownSelect
            label="Time parameter"
            errorText="Select a state"
            error={false}
            disabled={false}
            readOnly={isReadOnly}
            inlineLabel={false}
            width={width < 480 ? "100%" : "220px"}
            value={timeParam}
            onChange={(e) => setTimeParam(e.target.value)}
            data-testid={CREATERULE_TEST_IDS.TIME_PARAMETER_DROPDOWN}
          >
            <option value="">Select</option>
            <option
              value="Active between"
              selected={timeParam === "Active between"}
            >
              Active between
            </option>
          </DropdownSelect>

          <DropdownSelect
            label="Time"
            onChange={(e) => setTime("startTime", e.target.value)}
            data-testid={CREATERULE_TEST_IDS.START_TIME_DROPDOWN}
            value={startTime}
            errorText={!startTime ? "Select start time" : undefined}
            width={width < 480 ? "100%" : "164px"}
            readOnly={isReadOnly}
          >
            {timeOptions.map((time, index) => (
              <option key={time} value={time} selected={time === startTime}>
                {time}
              </option>
            ))}
          </DropdownSelect>

          <TimeFrameText>to</TimeFrameText>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "5px",
            }}
          >
            <DropdownSelect
              label="Time"
              onChange={(e) => setTime("endTime", e.target.value)}
              data-testid={CREATERULE_TEST_IDS.END_TIME_DROPDOWN}
              value={endTime}
              errorText={!endTime && startTime ? "Select end time" : undefined}
              width={width < 480 ? "100%" : "124px"}
              readOnly={isReadOnly}
            >
              {timeOptions.map((time, index) => (
                <option key={time} value={time} selected={time === startTime}>
                  {time}
                </option>
              ))}
            </DropdownSelect>
            {showText && (
              <Body size="small" color="#6F7171">
                Overnight alert
              </Body>
            )}
           
          </div>
           <DropdownSelect
              label="Time Zone"
              onChange={(e) => {
                dispatch(updateRuleValue({ propName: "customData", value: { timeZone: e.target.value } }));
                setTime("timeZone", e.target.value);
              }}
              data-testid={CREATERULE_TEST_IDS.TIME_ZONE_DROPDOWN}
              value={customData.timeZone}
              errorText={!customData.timeZone ? "Select time zone" : undefined}
              width={width < 480 ? "100%" : "264px"}
              readOnly={isReadOnly}
            >
              {timeZones.map((zone) => (
                <option key={zone.value} value={zone.value} selected={zone.value === customData.timeZone}>
                  {zone.title}
                </option>
              ))}
            </DropdownSelect>
        </CustomTFDropdownsFrame>

        <CustomTFDaysInWeek className={isReadOnly && "disabledDiv"}>
          {days.map((day) => (
            <FrameForDay
              key={day}
              isSelected={customData.selectedDays[day]}
              onClick={() => toggleDaySelection(day)}
              data-testid={CREATERULE_TEST_IDS.DAY_OF_WEEK}
            >
              <DayOfTheWeekText>{day}</DayOfTheWeekText>
            </FrameForDay>
          ))}
        </CustomTFDaysInWeek>
      </CustomTFFrame>
    </>
  );
};

export default CustomTimeFrame;
